import * as m from "mithril";
import '../../components/ModalDialog.css';
import CustomSvgIcon, { CustomSvgIconType } from "../../components/CustomSvgIcon";
import { PriceLevel, SeatPriceGuideItemDTO } from "../../apiclient/ApiDtos";
import { MessageProvider } from "../../context/AppMessages";
import { buildSeatFeatureClass } from "../seatselection/BusLayoutPage";

export default function SeatPriceDetailsDialog(): m.Component<{
    shouldOpen: boolean,
    title?: string,
    message?: string,
    messageProvider: MessageProvider,
    iconType?: CustomSvgIconType,
    iconThemeClass?: string,
    priceGuide: SeatPriceGuideItemDTO[],
    onClosed: () => void,
    actionItems?: { label: string, onclick: () => void }[]
}> {
    let dialogElem: HTMLDialogElement | null = null;

    return {
        oncreate(vnode) {
            dialogElem = vnode.dom as HTMLDialogElement;
        },

        onbeforeupdate(vnode) {
            if (dialogElem) {
                if (dialogElem.open) {
                    if (vnode.attrs.shouldOpen == false) {
                        dialogElem.close();
                    }
                } else {
                    if (vnode.attrs.shouldOpen) {
                        dialogElem.showModal();
                    }
                }
            }
        },


        view(vnode) {

            return m("dialog", {
                class: "dialog-modal"
            },
                [
                    vnode.attrs.title && m("div.card-header", { class: "pb-2 px-1 bg-white border-0" }, [
                        /* (vnode.attrs.iconType != undefined) ?
                            m("span.mr-1",
                                m(CustomSvgIcon, {
                                    iconType: vnode.attrs.iconType,
                                    themeCssClass: vnode.attrs.iconThemeClass ? vnode.attrs.iconThemeClass : "svg-small svg-warning"
                                }),
                            ) : null, */

                        (vnode.attrs.title != null) ?
                            m("span", { class: "font-weight-bold mb-3 text-primary" }, vnode.attrs.title) : null,

                    ]),
                    m("div.card-body.pt-1.px-1", [
                        (vnode.attrs.message != null) ?
                            m("div", { class: "mb-1 small" }, vnode.attrs.message) : null,

                        vnode.children,

                        //priceGradeMap.size < 4 && 
                        m("div.mt-3 ",

                            m("div.mt-2",
                                [...vnode.attrs.priceGuide]
                                    .map(seatPriceItem =>
                                        m("div.d-flex.justify-content-between.align-items-center my-1", [
                                            m("div.seat", [
                                                m("span.seat seat-pricing en-only mr-2 ", {
                                                    class: buildSeatFeatureClass(seatPriceItem.classification)
                                                }, "")
                                            ]),
                                            m("div.text-success", [
                                                `${seatPriceItem.price.currency} `,
                                                seatPriceItem.price.amount.toLocaleString("en-US")
                                            ])
                                        ])
                                    )
                            )
                        )


                    ]),
                    [
                        (vnode.attrs.actionItems != null) ?
                            m("div.card-footer.px-1", { class: "text-right border-0 bg-white pt-0" },
                                vnode.attrs.actionItems.map(item => {
                                    return m("button", {
                                        class: 'btn btn-outline-primary btn-sm mr-1',
                                        onclick: function (event) {
                                            item.onclick();
                                        }
                                    }, item.label)
                                })
                            ) : null
                    ],


                ]
            )
        }
    };
}



export function getPriceLevelCssClass(priceLevel: PriceLevel): string {
    if (priceLevel.max > 3) {
        if (priceLevel.value == 1) {
            return " seat-type seat-price-lowest";
        } else {
            return " seat-type seat-price-a" + (priceLevel.max - priceLevel.value + 1);
        }
    }
    let seatFeatureClass = "";
    if (priceLevel.max >= 3 &&
        priceLevel.value == 1) {
        seatFeatureClass = "seat-price-lowest";
    } else if (priceLevel.max >= 3 &&
        priceLevel.value == priceLevel.max) {
        seatFeatureClass = "seat-price-highest";
    } else if (priceLevel.max > 2 &&
        priceLevel.value == priceLevel.max) {
        seatFeatureClass = "seat-price-highest";
    } else if (priceLevel.max == 2) {
        if (priceLevel.value == priceLevel.max) {
            seatFeatureClass = "seat-price-normal"
        } else {
            seatFeatureClass = "seat-price-lowest"
        }
    } else {
        seatFeatureClass = "seat-price-normal";
    }
    return seatFeatureClass;
}
